import { z } from "zod";
import { uuidLoose } from "./uuid.js";
/**
 * `POST /v1/storefront/cart/items` body. Adding a variant that's already in
 * the cart increments the existing line's quantity (server-side merge);
 * client need not check first.
 *
 * `variantId` uses `uuidLoose` (not `z.uuid()`) so the P02-T12 seed's
 * version-0 UUIDs are accepted during dev/staging. See uuid.ts for the
 * rationale.
 */
export const AddCartItemBody = z.object({
    variantId: uuidLoose,
    quantity: z.number().int().min(1).max(9999),
});
/**
 * `PATCH /v1/storefront/cart/items/:lineId` body. Quantity 0 is rejected —
 * the client should issue DELETE to remove a line.
 */
export const UpdateCartItemBody = z.object({
    quantity: z.number().int().min(1).max(9999),
});
/**
 * `POST /v1/storefront/cart/active-location` body (P13-T5).
 *
 * Switches the cart's active company location — which drives per-location
 * discount pricing on every cart line. On success the service re-prices all
 * lines and returns the updated CartDTO.
 *
 * `company_location_id` uses `uuidLoose` (not `z.uuid()`) so the P02-T12
 * seed's version-0 UUIDs are accepted during dev/staging. See uuid.ts for
 * the rationale. snake_case field name matches the storefront wire protocol
 * (all other body DTOs in this file use camelCase; snake_case is used here
 * to match the REST/JSON convention established in the spec P13-T5).
 */
export const SwitchActiveLocationBody = z.object({
    company_location_id: uuidLoose,
});
